import { Typography } from '@material-ui/core'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { CostDetailCollection, CostDetailProps, CurrencyWithColor, formatCurrency } from '../components/CostDetail'
import Table, { TableColumn } from '../components/Table'
import { OrderContext, OrderSimulationData, RequestLineItem, ResponseLineItem } from '../OrderContext'

type ReturnDisplayProps = { 
    type: 'returns' | 'exchanges', 
    title: string, 
    disableSmall?: boolean, 
    simulateOverride?: OrderSimulationData 
}

const ReturnDisplay: React.FC<ReturnDisplayProps> = ({ type, title, disableSmall, simulateOverride }) => {
    const { simulate } = useContext(OrderContext)
    const { t } = useTranslation()

    const s = simulateOverride || simulate

    if (!s) return null

    const items = s[type]

    const columns: TableColumn<ResponseLineItem & RequestLineItem>[] = [
        { title: t('description'), property: 'description', flex: 3 },
        { title: t('material_number'), property: 'material', flex: 2 },
        { title: t('lot_number'), property: 'batch' },
        { title: t('invoice'), property: 'invoiceNumber', flex: 2 },
        { title: t('unit_price'), property: 'unitPrice', render: p => formatCurrency(p as number) },
        { title: t('quantity'), property: 'quantity' },
        { title: t('total_in', { currency: s.currency }), property: 'netAmount', align: 'right', render: a => <CurrencyWithColor amount={a as number} />, flex: 2 },
    ]

    const costDetails: CostDetailProps[] = [
        { label: t('subtotal_returns'), amount: s?.returnSubtotal || 0 },
        { label: t('taxes'), amount: s?.returnTaxAmount || 0 },
        { label: t('total_refund_amount'), amount: s?.returnRefundAmount || 0 },
        { label: t('pick_up_cost'), amount: s?.returnShippingCost || 0 },
        { label: t('total_credit_amount'), amount: s?.returnCreditAmount || 0 },
    ]

    return items?.length
        ? <>
            <Typography variant='h5' style={{ marginBottom: 30 }}>{title}</Typography>

            <Table disableSmall={disableSmall} collapse columns={columns} data={items} />

            <CostDetailCollection details={costDetails} />
        </>
        : null
}

export default ReturnDisplay
